//

import Card from './Card';
import Paper from './Paper';
import Input from './Input';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import CssBaseline from './CssBaseline';
import Autocomplete from './Autocomplete';
import Chip from './Chip';
import Dialog from './Dialog';
import Tab from './Tab';
import ToggleButton from './ToggleButton';
import { responsiveOverrides, responsiveGlobalStyles } from '../responsive.config';
/* import Accordion from './Accordion'; */

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
  const components = Object.assign(
    Card(theme),
    Input(theme),
    Paper(theme),
    Button(theme),
    Tooltip(theme),
    Backdrop(theme),
    Typography(theme),
    CssBaseline(theme),
    Autocomplete(theme),
    Chip(theme),
    Dialog(theme),
    Tab(),
    ToggleButton(),
    // Phone-only fixes live in one file: ../responsive.config.js
    responsiveOverrides(theme)
    /* Accordion(theme), */
  );
  components.MuiCssBaseline.styleOverrides = {
    ...components.MuiCssBaseline.styleOverrides,
    ...responsiveGlobalStyles(theme),
  };
  return components;
}
